import axios from '../axios'
import type { InstrumentModel, InstrumentRepository } from '@trading/core'

export class InstrumentsApiAxios implements InstrumentRepository {
  async getInstruments(): Promise<InstrumentModel[]> {
    const response = await axios.get<{ data: InstrumentModel[] }>('market/instruments');
    return response.data.data;
  }
}
